// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"38eff388","381":"dab409ec","398":"e180ef60","554":"53619fe8","586":"71ac233d","763":"d0b99547","979":"988609f6"}[chunkId] + ".chunk.js";
};